import React, { useEffect, useState } from 'react';
import apiRequest from '../api/client';
import './DownloadApkButton.css';

// Bouton "Télécharger l'APK" (2026-09-24) — page de connexion + barre du haut
// du portail company. Le lien vient du manifeste PUBLIC de mise à jour du POS
// (GET /api/app/manifest/?platform=android, appupdates/views.py) : c'est
// toujours le DERNIER APK publié dans l'admin Django (App releases, kind=apk),
// rien à changer ici à chaque nouvelle version. Aucun APK publié / manifeste
// injoignable -> le bouton ne s'affiche pas.
let cache = null;

const loadApk = () => {
  if (!cache) {
    cache = apiRequest('/app/manifest/?platform=android')
      .then((m) => (m?.apk?.url ? m.apk : null))
      .catch(() => { cache = null; return null; });
  }
  return cache;
};

const sizeLabel = (bytes) => (bytes ? ` · ${Math.round(bytes / (1024 * 1024))} Mo` : '');

export default function DownloadApkButton({ variant = 'button' }) {
  const [apk, setApk] = useState(null);

  useEffect(() => {
    let cancelled = false;
    loadApk().then((a) => { if (!cancelled) setApk(a); });
    return () => { cancelled = true; };
  }, []);

  if (!apk) return null;

  const title = `Application POS${apk.version_name ? ` v${apk.version_name}` : ''}${sizeLabel(apk.size)}`;

  return (
    <a
      className={variant === 'link' ? 'apk-dl-link' : 'apk-dl-btn'}
      href={apk.url}
      download
      title={title}
    >
      <span aria-hidden="true">📲</span>
      {variant === 'link' ? ' APK' : ` Télécharger l'APK${apk.version_name ? ` (v${apk.version_name})` : ''}`}
    </a>
  );
}
